import Store from '../Store';
import RestClient from 'shared/Network/RestClient';
import { toast } from 'react-toastify';
import { observable, action } from 'mobx';

class ListingsStoreClass extends Store {
    @observable accessor accounts = [];
    @observable accessor listings = [];

    fetchData() {
        return new Promise(async (resolve, reject) => {
            if (this.status.fetched) {
                return resolve(this.list);
            }

            try {
                this.status.loading = true;

                const accounts = await this.fetchRoute('accountsoverview/accounts');
                const skus = await this.fetchRoute('accountsoverview/listings/skus');

                this.status.fetched = true;

                this.list = accounts;
                this.products = skus;

                this.status.loading = false;
                resolve(this.list);
            } catch (error) {
                this.status.error = error.error?.message || error.data?.error || error.error || error.message || JSON.stringify(error) || 'An error occurred';
                this.status.loading = false;
                reject(error);
            }
        });
    }

    async fetchRoute(route = '') {
        const request = RestClient.prepareRequest('GET', route);

        try {
            const res = await request.send();

            if (res.success && 'data' in res) {
                return res.data?.value || res.data;
            } else {
                throw res.error?.message || res.data?.error || res.error || res.message || JSON.stringify(res) || 'An error occurred';
            }
        } catch (error) {
            toast.error(`Error fetching "${route}": ${error}`);
            return [];
        }
    }

    @action
    async fetchListingsByAccountId(accountId) {
        try {
            const listings = await this.fetchRoute(`accountsoverview/accounts/${accountId}/listings`);
            this.listings = listings
        } catch (error) {
            toast.error(`Error fetching listings for account ID "${accountId}": ${error}`);
            this.listings = [];
        }
    }

    async deleteListing(listingId) { 
        const request = RestClient.prepareRequest('DELETE', `accountsoverview/listings/${listingId}`);
        const response = await request.send();
        if (response.success) {
            this.listings.find(listing => listing.id === listingId).soft_deleted = true;
        }
        console.log(this.listings);
        return response.success;
    }

    @action
    async saveListings(accountId, listingsToSave) {
        try {

            const request = RestClient.prepareRequest('POST', `accountsoverview/accounts/${accountId}/listings`);
            request.setData({ listings: listingsToSave });
            const response = await request.send();

            if (response.success) {
                toast.success('Listings saved successfully.');
                this.listings = this.listings.map(listing => {
                    const savedListing = response.data.find(l => l.sku === listing.sku);
                    return savedListing ? savedListing : listing;
                });
            } else {
                throw response.error?.message || response.data?.error || response.error || response.message || JSON.stringify(response) || 'An error occurred';
            }
        } catch (error) {
            toast.error(`Error saving listings: ${error}`);
        }
    }
}

const ListingsStore = new ListingsStoreClass('accountsoverview/accounts');

export default ListingsStore;